export const DAY_TYPES = [
  { value: "Select", label: "Select" },
  { value: "Full Day", label: "Full Day" },
  { value: "First Half", label: "First Half" },
  { value: "Second Half", label: "Second Half" },
];

export const CARD_ICONS = [
  "ti-calendar-event",
  "ti-vaccine",
  "ti-hexagon-letter-c",
  "ti-hexagonal-prism-plus",
];
